import styled from '@emotion/styled';
import { Box, CircularProgress, Divider, Grid, IconButton, Stack, Typography } from '@mui/material';
import moment from 'moment';
import React, { useEffect, useState, useRef } from 'react';
import ReactToPrint from 'react-to-print';
import { useParams } from 'react-router';
import { useSelector } from 'react-redux';
import Iconify from '../../../fl-components/Iconify';
import { getSubmissionById } from '../../../service/test.submission.service';
import UploadAndMCQView from './UpalodAndMCQView';
import TypeTestView from './TypeTestView';

const RootStyle = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden'
});

export default function TestResult() {
  const currentUser = useSelector((state) => state.auth.currentUser);
  const params = useParams();
  // Loading state
  const [loading, setLoading] = useState(true);
  // Test details
  const [testDetails, setTestDetails] = useState(null);
  // Submission details
  const [submissionDetails, setSubmissionDetails] = useState(null);
  // test ref
  const containerRef = useRef(null);

  useEffect(() => {
    const fetchSubmissionDetail = async () => {
      const res = await getSubmissionById(params.id);

      if (res) {
        setSubmissionDetails(res);
        setTestDetails(res.testId);
        setLoading(false);
      }
    };

    if (submissionDetails === null) fetchSubmissionDetail();
  }, []);

  return (
    <RootStyle
      title="Fainlearn | Online Test"
      isDivRender={false}
      style={{
        display: `${loading ? 'flex' : ''}`,
        width: `${loading ? '100%' : ''}`,
        height: `${loading ? '100%' : ''}`,
        justifyContent: `${loading ? 'center' : ''}`,
        alignItems: `${loading ? 'center' : ''}`
      }}
    >
      {loading ? (
        <CircularProgress />
      ) : (
        <Box width="100%" maxWidth="700px" margin="0 auto" ref={containerRef}>
          <Stack direction="row" justifyContent="end" alignItems="center" my={2}>
            <ReactToPrint
              documentTitle={`Result - ${testDetails.name}`}
              // eslint-disable-next-line react/no-unstable-nested-components
              trigger={() => (
                <IconButton>
                  <Iconify icon="fluent:print-20-filled" width={20} height={20} />
                </IconButton>
              )}
              content={() => containerRef.current}
            />
          </Stack>

          <Typography fontSize={22} fontWeight="bold" mb={1}>
            Test Details
          </Typography>
          <Grid container spacing={2} mb={2}>
            <Grid item sm={6} xs={12}>
              <Typography fontWeight="bold">Test name</Typography>
              <Typography>{testDetails.name}</Typography>
            </Grid>
            <Grid item sm={6} xs={12}>
              <Typography fontWeight="bold">Class name</Typography>
              <Typography>{submissionDetails.classId.name}</Typography>
            </Grid>
            <Grid item sm={6} xs={12}>
              <Typography fontWeight="bold">Obtain mark</Typography>
              <Typography>{submissionDetails.totalMark}</Typography>
            </Grid>
            <Grid item sm={6} xs={12}>
              <Typography fontWeight="bold">Test total mark</Typography>
              <Typography>{testDetails.totalMark}</Typography>
            </Grid>
            <Grid item sm={6} xs={12}>
              <Typography fontWeight="bold">Test conducted at</Typography>
              <Typography>{moment(testDetails.startTime).format('DD/MM/yyyy LT')}</Typography>
            </Grid>
          </Grid>

          {currentUser.profile !== 'student' && (
            <>
              <Divider sx={{ mb: 2 }} />
              <Typography fontSize={22} fontWeight="bold" mb={1}>
                Student Details
              </Typography>
              <Grid container spacing={2} mb={2}>
                <Grid item sm={6} xs={12}>
                  <Typography fontWeight="bold">Student name</Typography>
                  <Typography>{submissionDetails.studentId.fullName}</Typography>
                </Grid>
                <Grid item sm={6} xs={12}>
                  <Typography fontWeight="bold">Student email</Typography>
                  <Typography>{submissionDetails.studentId?.email ?? '-'}</Typography>
                </Grid>
              </Grid>
            </>
          )}

          <Divider sx={{ mb: 2 }} />
          <UploadAndMCQView
            testDetails={testDetails}
            submissionDetails={submissionDetails}
            currentUser={currentUser}
          />
          <TypeTestView
            testDetails={testDetails}
            submissionDetails={submissionDetails}
            currentUser={currentUser}
          />
        </Box>
      )}
    </RootStyle>
  );
}
